import { createColumnHelper } from '@tanstack/react-table'
import { Button } from '@radix-ui/themes'
import './styles.css'
import { DeviceEvent, getCategoryByEventType, getDetails, getEventName } from '../../types/DeviceEventTypes'
import { formatUtcTimestamp } from '../../utils/dates'

export const deviceEventColumns = (
  setShowEventPopout: (show: boolean) => void,
  setPopoutEventData: (event: DeviceEvent) => void
) => {

  const columnHelper = createColumnHelper<DeviceEvent>()

  return [
    columnHelper.accessor('eventType', {
      header: 'Event Name',
      cell: (info) => getEventName(info.getValue()),
      enableSorting: false,
    }),
    columnHelper.accessor('eventType', {
      header: 'Category',
      cell: (info) => getCategoryByEventType(info.getValue()),
      enableSorting: false,
    }),
    columnHelper.accessor('eventTime', {
      header: 'Timestamp (UTC)',
      cell: (info) => formatUtcTimestamp(info.getValue()),
      enableSorting: true,
    }),
    columnHelper.accessor('eventType', {
      header: 'Details',
      cell: (info) => <>{getDetails(info.getValue(), info.row.original)}</>,
      enableSorting: false,
    }),
    {
      id: 'actions',
      cell: (row: { row: { original: DeviceEvent } }) => (
        <Button
          size={'2'}
          className="cursor-pointer float-right"
          onClick={() => {
            setPopoutEventData(row.row.original)
            setShowEventPopout(true)
          }}
          variant="outline"
        >
          View
        </Button>
      ),
    },
  ]
}
